import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import ReactTooltip from "react-tooltip";

const SideNav = () => {
  const proposal = useSelector((state) => state.proposal);
  const qpr = useSelector((state) => state.qpr_data);

  const [validation, setValidation] = useState(true);

  const location = useLocation();
  const { qpr_id, qh } = location.state;
  
  const validationIconCss = (submit_status) => {
    switch(submit_status) {
      case 0:
        return "text-warning";
      case 1:
        return "text-success";
      default:
        return "";
    }
  }

  useEffect(() => {
    setValidation(true);
    if(qpr.form_validation.basic_information.submit_status!=1) {
      setValidation(false);
    } else if(qpr.form_validation.research_background.submit_status!=1) {
      setValidation(false);
    } else if(qpr.quarter>1 && qpr.form_validation.response_to_te.submit_status!=1) {
      setValidation(false);
    } else if(qpr.form_validation.progress_report.submit_status!=1) {
      setValidation(false);
    } else if(qpr.form_validation.plan_for_remaining_quarter.submit_status!=1) {
      setValidation(false);
    } else if(qpr.form_validation.project_gantt_chart.submit_status!=1) {
      setValidation(false);
    } else if(qpr.form_validation.progress_ppt.submit_status!=1) {
      setValidation(false);
    }
    // setValidation(true);
  });

  const page_location = location.pathname.split('/')[4];
  let page_name = page_location;
  page_name = page_name.replaceAll("-", "_");
  let page={};
  page[page_name]="active";

  return (
    <>
      <div className='card bg-info border-info' style={{"borderTop": "3px solid"}}>
        <div className='card-header bg-info text-white'><strong>Proposal No: {proposal && proposal.registerNumber}</strong></div>
        <div className='qpr-nav card-body p-0'>
          <nav className="navbar navbar-light">
            <ul className="navbar-nav">
              <li className="nav-item">
                <div className="row">
                  <div className="col-10">
                    <Link className={"nav-link " + page.basic_information} to={'/user/qpr/add/basic-information'} state={{ qpr_id: qpr_id, qh: qh }} >Basic Information<span className='text-danger'>*</span></Link>
                  </div>
                  <div className="col-2 pt-2">
                    <FontAwesomeIcon icon={faCheckCircle} className={validationIconCss(Object.keys(qpr).length>0 && qpr.form_validation.basic_information.submit_status)} />
                  </div>
                </div>
              </li>
              <li className="nav-item">
                <div className="row">
                  <div className="col-10">
                    <Link className={"nav-link " + page.research_background} to={'/user/qpr/add/research-background'} state={{ qpr_id: qpr_id, qh: qh }} >Research Background<span className='text-danger'>*</span></Link>
                  </div>
                  <div className="col-2 pt-2">
                    <FontAwesomeIcon icon={faCheckCircle} className={validationIconCss(Object.keys(qpr).length>0 && qpr.form_validation.research_background.submit_status)} />
                  </div>
                </div>
              </li>
              {qpr.basic_information.quarter != 1 &&
              <li className="nav-item">
                <div className="row">
                  <div className="col-10">
                    <Link className={"nav-link " + page.response_to_te} to={'/user/qpr/add/response-to-te'} state={{ qpr_id: qpr_id, qh: qh }} >Response to Technical Experts<span className='text-danger'>*</span></Link>
                  </div>
                  <div className="col-2 pt-2">
                    <FontAwesomeIcon icon={faCheckCircle} className={validationIconCss(Object.keys(qpr).length>0 && qpr.form_validation.response_to_te.submit_status)} />
                  </div>
                </div>
              </li> 
              }
              <li className="nav-item">
                <div className="row">
                  <div className="col-10">
                    <Link className={"nav-link " + page.progress_report} to={'/user/qpr/add/progress-report'} state={{ qpr_id: qpr_id, qh: qh }} >Progress Report<span className='text-danger'>*</span></Link>
                  </div>
                  <div className="col-2 pt-2">
                    <FontAwesomeIcon icon={faCheckCircle} className={validationIconCss(Object.keys(qpr).length>0 && qpr.form_validation.progress_report.submit_status)} />
                  </div>
                </div>
              </li>
              <li className="nav-item">
                <div className="row">
                  <div className="col-10">
                    <Link className={"nav-link " + page.progress_ppt} to={'/user/qpr/add/progress-ppt'} state={{ qpr_id: qpr_id, qh: qh }} >Progress PPT<span className='text-danger'>*</span></Link>
                  </div>
                  <div className="col-2 pt-2">
                    <FontAwesomeIcon icon={faCheckCircle} className={validationIconCss(Object.keys(qpr).length>0 && qpr.form_validation.progress_ppt.submit_status)} />
                  </div>
                </div>
              </li>
              <li className="nav-item">
                <div className="row">
                  <div className="col-10">
                    <Link className={"nav-link " + page.plan_for_remaining_quarter} to={'/user/qpr/add/plan-for-remaining-quarter'} state={{ qpr_id: qpr_id, qh: qh }} >Plan For Remaining Quarters<span className='text-danger'>*</span></Link>
                  </div>
                  <div className="col-2 pt-2">
                    <FontAwesomeIcon icon={faCheckCircle} className={validationIconCss(Object.keys(qpr).length>0 && qpr.form_validation.plan_for_remaining_quarter.submit_status)} />
                  </div>
                </div>
              </li>
              <li className="nav-item">
                <div className="row">
                  <div className="col-10">
                    <Link className={"nav-link " + page.project_gantt_chart} to={'/user/qpr/add/project-gantt-chart'} state={{ qpr_id: qpr_id, qh: qh }} >Project Gantt Chart<span className='text-danger'>*</span></Link>
                  </div>
                  <div className="col-2 pt-2">
                    <FontAwesomeIcon icon={faCheckCircle} className={validationIconCss(Object.keys(qpr).length>0 && qpr.form_validation.project_gantt_chart.submit_status)} />
                  </div>
                </div>
              </li>
              <li className="nav-item text-center">
                {validation?
                  <Link className={"nav-link btn btn-success btn-sm text-white p-2"} to={'/user/qpr/add/submit'} state={{ qpr_id: qpr_id, qh: qh }} data-tip data-for="submit1" >
                    Submit
                    <ReactTooltip id="submit1" place="top" effect="solid">
                      Click for final submition
                    </ReactTooltip>
                  </Link>:
                  <Link className={"nav-link btn btn-default btn-sm p-2"} to={'#'} data-tip data-for="submit2" >
                    Submit
                    <ReactTooltip id="submit2" place="top" effect="solid">
                      Please fill all mandatory forms
                    </ReactTooltip>
                  </Link>
                }                
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <p><span><FontAwesomeIcon icon={faCheckCircle} className="" /> Not filled</span>&nbsp;&nbsp;
      <span><FontAwesomeIcon icon={faCheckCircle} className="text-warning" /> Incomplete</span>&nbsp;&nbsp;
      <span><FontAwesomeIcon icon={faCheckCircle} className="text-success" /> Filled</span></p>
      <p><span className='text-danger'>*</span> <span>Mandatory to fill</span></p>
    </>
  );
}

export default SideNav;